import { registerQuery } from 'data-fetching-client';
import { fetchAssetById, fetchAssetsByIds } from 'personalization-lib/api/clients/assetApiClient';
import { fetchHasSmartContent } from 'personalization-lib/api/clients/contentApiClient';
const getAssetMap = assets => Object.fromEntries(assets.map(asset => [asset.id, asset]));
export const ASSETS_BY_IDS_QUERY = registerQuery({
  fieldName: 'assetsById',
  args: ['source', 'ids'],
  fetcher: args => fetchAssetsByIds(args).then(getAssetMap)
});
export const ASSET_BY_ID_QUERY = registerQuery({
  fieldName: 'assetById',
  args: ['source', 'id'],
  fetcher: args => fetchAssetById(args)
});
export const HAS_SMART_CONTENT_QUERY = registerQuery({
  fieldName: 'hasSmartContent',
  args: ['id'],
  fetcher: args => fetchHasSmartContent(args)
});